import { useNavigation } from "@react-navigation/native";
import { authActions } from "./auth/AuthReducer";
import { useAlert, useAppDispatch, RequestOptions, useRequest } from "@grassrootly/rn-core";

export default function useBaseRequest<TData, TPayload>(
  request: (payload: TPayload) => Promise<TData>,
  options: RequestOptions<TData, TPayload> = {}
) {
  const navigation = useNavigation();
  const dispatch = useAppDispatch();
  const { danger } = useAlert();

  const onError = (error: any) => {
    if (error?.statusCode === 401 && error?.message === "Token expired") {
      danger({ message: "Session expired. Please log in." });
      dispatch(authActions.setUser(null));
      navigation.reset({ index: 0, routes: [{ name: "login" }] });
      return;
    }
    if (options.onError) {
      options.onError(error);
    }
    if (!options.skipErrorHandler) {
      console.log("request error", error);
      danger({ message: error?.message || "Server error." });
    }
  };

  return useRequest(request, {
    ...options,
    onError,
  });
}
